import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content" }
const _hoisted_2 = { style: {"width":"100%"} }

import DtoSearch from "@/shared/model/DtoSearch";
import SogCard from "@/shared/ui/SogCard.vue";
import SogCardTitle from "@/shared/ui/SogCardTitle.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogDataLabel from "@/shared/ui/SogDataLabel.vue";

interface Props {
  data?:DtoSearch,
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*@__PURE__*/_defineComponent({
  __name: 'VehicleRegistrationInfo',
  props: {
    data: { default: undefined }
  },
  setup(__props: any) {


const props = __props



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SogCard, null, {
      default: _withCtx(() => [
        _createVNode(SogCardTitle, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.data?.insuranceNumber), 1)
          ]),
          _: 1
        }),
        _createVNode(SogCardContent, null, {
          default: _withCtx(() => [
            _createElementVNode("table", _hoisted_2, [
              _withDirectives(_createElementVNode("tr", null, [
                _cache[0] || (_cache[0] = _createElementVNode("td", null, "PartnershipId", -1)),
                _createElementVNode("td", null, [
                  _createVNode(SogDataLabel, {
                    value: __props.data?.partnershipId
                  }, null, 8, ["value"])
                ])
              ], 512), [
                [_vShow, __props.data?.partnershipId]
              ]),
              _createElementVNode("tr", null, [
                _cache[1] || (_cache[1] = _createElementVNode("td", null, "eVb", -1)),
                _createElementVNode("td", null, [
                  _createVNode(SogDataLabel, {
                    value: __props.data?.evb
                  }, null, 8, ["value"])
                ])
              ]),
              _createElementVNode("tr", null, [
                _cache[2] || (_cache[2] = _createElementVNode("td", null, "Kennzeichen", -1)),
                _createElementVNode("td", null, [
                  _createVNode(SogDataLabel, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(__props.data?.kennzeichen), 1)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("tr", null, [
                _cache[3] || (_cache[3] = _createElementVNode("td", null, "Versicherungsbeginn", -1)),
                _createElementVNode("td", null, [
                  _createVNode(SogDataLabel, {
                    value: __props.data?.datumVersicherungsBeginn,
                    "value-type": "DateTime"
                  }, null, 8, ["value"])
                ])
              ]),
              _createElementVNode("tr", null, [
                _cache[4] || (_cache[4] = _createElementVNode("td", null, "Versicherungsende", -1)),
                _createElementVNode("td", null, [
                  _createVNode(SogDataLabel, {
                    value: __props.data?.kennzeichenDatumGueltigBis,
                    "value-type": "DateTime"
                  }, null, 8, ["value"])
                ])
              ]),
              _createElementVNode("tr", null, [
                _cache[5] || (_cache[5] = _createElementVNode("td", null, "FIN", -1)),
                _createElementVNode("td", null, [
                  _createVNode(SogDataLabel, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(__props.data?.fahrzeugIdentifizierungsNummer), 1)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("tr", null, [
                _cache[6] || (_cache[6] = _createElementVNode("td", null, "Fahrzeugart", -1)),
                _createElementVNode("td", null, [
                  _createVNode(SogDataLabel, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(__props.data?.fahrzeugArtDescription), 1)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("tr", null, [
                _cache[7] || (_cache[7] = _createElementVNode("td", null, "Hersteller", -1)),
                _createElementVNode("td", null, [
                  _createVNode(SogDataLabel, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(__props.data?.fahrzeugHersteller), 1)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("tr", null, [
                _cache[8] || (_cache[8] = _createElementVNode("td", null, "Text Fahrzeugklasse", -1)),
                _createElementVNode("td", null, [
                  _createVNode(SogDataLabel, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(__props.data?.textFahrzeugklasse), 1)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("tr", null, [
                _cache[9] || (_cache[9] = _createElementVNode("td", null, "Text Aufbau", -1)),
                _createElementVNode("td", null, [
                  _createVNode(SogDataLabel, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(__props.data?.textAufbau), 1)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("tr", null, [
                _cache[10] || (_cache[10] = _createElementVNode("td", null, "Haltername", -1)),
                _createElementVNode("td", null, [
                  _createVNode(SogDataLabel, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(__props.data?.halterVorname) + " " + _toDisplayString(__props.data?.halterNachname), 1)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("tr", null, [
                _cache[11] || (_cache[11] = _createElementVNode("td", null, "Halteraddresse", -1)),
                _createElementVNode("td", null, [
                  _createVNode(SogDataLabel, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(__props.data?.halterStrasse) + " " + _toDisplayString(__props.data?.halterHausnummer), 1)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("tr", null, [
                _cache[13] || (_cache[13] = _createElementVNode("td", null, null, -1)),
                _createElementVNode("td", null, [
                  _createVNode(SogDataLabel, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(__props.data?.halterPostleitzahl) + " " + _toDisplayString(__props.data?.halterWohnort), 1),
                      _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1)),
                      _createTextVNode(_toDisplayString(__props.data?.halterStaat), 1)
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})